export const ALL_IN_APP_NOTIFICATIONS = 'ALL_IN_APP_NOTIFICATIONS';
export const TASK = 'TASK';
